import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-top">

        <div className="footer-brand">
          <h2>BADTAMEEZDIL</h2>
          <p>GAMESTORE</p>
          <span>Your trusted Valorant VP store.</span>
        </div>

        <div className="footer-links">
          <h3>STORE</h3>
          <Link to="/valorant-vp">Valorant VP</Link>
          <Link to="/valorant-accounts">Valorant Accounts</Link>
        </div>

        <div className="footer-links">
          <h3>SUPPORT</h3>

         <a
  href="#"
  onClick={(e) => {
    e.preventDefault();

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = "mailto:badtameezdilgamestore@gmail.com";
    } else {
      window.open(
        "https://mail.google.com/mail/?view=cm&fs=1&to=badtameezdilgamestore@gmail.com",
        "_blank"
      );
    }
  }}
>
  Contact Us
</a>

          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 BadtameezDil GameStore. All rights reserved.</p>
        <p>Valorant is a trademark of Riot Games.</p>
      </div>

    </footer>
  )
}

export default Footer

